import React from "react";
import { Container } from "react-bootstrap";
import HelmetWrapper from "../../HelmetWrapper";
import ReferralStructure from "./ReferralStructure";

const RefferalsLanding = ({ userInfoData }) => {
  return (
    <HelmetWrapper title="WTF: Referral">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <ReferralStructure userInfoData={userInfoData} />

        {/* <Row>
          <Col>
            <CmnFilters
              from={"referrals"}
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              isLoading={referralsLoading}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <RefferalStat />
          </Col>
        </Row>
        <Row>
          <Col>
            <ReferralListings
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              userInfoData={userInfoData}
              callFunction={() => {
                getFDPaymentsAccessData(filters);
                getRefferalStatData(filters);
              }}
              prevFilters={(({ limit, page, added_to_lead, ...rest }) => rest)(
                filters
              )}
            />
          </Col>
        </Row> */}
      </Container>
    </HelmetWrapper>
  );
};

export default RefferalsLanding;
